import { useServiceWorkerMessages } from '@/hooks/useServiceWorkerMessages';
import { useUserNotificationsChannel } from '@/hooks/useUserNotificationsChannel';

export const NotificationManager = () => {
  useUserNotificationsChannel();
  useServiceWorkerMessages();

  return null;
};
